import React from 'react';
import { Box, Typography, makeStyles, GRAY } from '@applyboard/ui-components';
import ConditionalAcceptanceInfo from "../../../ConditionalAcceptanceInfo";
var useStyles = makeStyles({
  box: {
    paddingTop: '12px',
    borderTop: "1px solid ".concat(GRAY[18]),
    marginTop: '11px'
  },
  font: {
    color: GRAY[10]
  },
  link: {
    paddingTop: '10px'
  }
});
var ConditionalInfo = function ConditionalInfo(props) {
  var eslMessage = props.eslMessage;
  var classes = useStyles();
  var infoClassName = "".concat(classes.box);
  return /*#__PURE__*/React.createElement(Box, {
    className: infoClassName
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph",
    className: classes.font,
    gutterBottom: true
  }, "This program requires you to complete an English as a Second Language (ESL) course. You will need to enroll and complete this course prior to starting this academic program."), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, /*#__PURE__*/React.createElement(ConditionalAcceptanceInfo, {
    buttonText: "What is an ESL course?",
    modalText: eslMessage
  })));
};
export default ConditionalInfo;